export default __webpack_public_path__ + "static/media/undraw_super_thank_you_obwk.149859a9.svg";